import { apiFetch, toQuery } from "./legacy-integration-service";

//#region Type definitions

export type SearchWarehouseOptions = {
    fieldCompanyId: number;
    name?: string | undefined | null;
};

export type SearchWarehouseItemResponse = {
    id: number;
    name: string;
};

export type SearchWarehouseResponse = SearchWarehouseItemResponse[];

export type GetWarehouseByIdResponse = {
    id: number;
    name: string;
};

//#endregion

export async function searchWarehouses(options: SearchWarehouseOptions): Promise<SearchWarehouseResponse> {
    return await apiFetch<SearchWarehouseResponse>(`/warehouses/search?${toQuery(options)}`, {
        headers: { "Content-Type": "application/json" },
    });
}

export async function getWarehouseById(id: number): Promise<GetWarehouseByIdResponse> {
    return await apiFetch<GetWarehouseByIdResponse>(`/warehouses/${id}`, {
        headers: { "Content-Type": "application/json" },
    });
}
